const companyLangs = {
  error: {
    companyFail: "lấy danh sách công ty lỗi",
  },
};

export default companyLangs;
